import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
} from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { OnDemandResponse, OnDemandType } from '../data/on-demand.model';
import { environment } from 'src/environments/environment';
import { ButtonComponent } from '../../../shared/ui-common/button/button.component';
import { Account } from 'src/app/shared/data/models/account.model';
import { PillComponent } from '../../../shared/ui-common/pill/pill.component';
import { SharedService } from 'src/app/shared/data/shared.service';
import { TranslatePipe } from 'src/app/shared/data/pipes/translate.pipe';
import { RouterLink, RouterModule } from '@angular/router';

@Component({
  selector: 'app-open-case',
  imports: [
    CommonModule,
    ButtonComponent,
    PillComponent,
    TranslatePipe,
    RouterModule,
    RouterLink,
  ],
  templateUrl: './open-case.component.html',
  styleUrl: './open-case.component.scss',
})
export class OpenCaseComponent implements OnInit {
  @Input() type: OnDemandType = 'mind';
  @Input() onDemandResponse: OnDemandResponse | null = null;
  @Input() account: Account | null = null;

  @Output() saveNoteTextChanged = new EventEmitter<string>();

  @ViewChild('textarea') textareaRef!: ElementRef<HTMLTextAreaElement>;

  s3BaseUrl = environment.s3BaseUrl;
  companyLogo = signal<string>('');
  width = window.innerWidth;
  editNote = false;

  @HostListener('window:resize')
  onResize(): void {
    this.width = window.innerWidth;
  }

  get isHowdyLogo(): boolean {
    return this.companyLogo().includes('HRONWellbeing');
  }

  constructor(
    private sharedService: SharedService,
    private location: Location,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.companyLogo.set(this.sharedService.getCompanyLogoUrl(true));
  }

  getHowdyLogo(): void {
    this.companyLogo.set(this.sharedService.getHowdyLogoUrl(true));
  }

  onNoteTextChange(event: Event): void {
    const note = (event.target as HTMLTextAreaElement).value;

    if (this.onDemandResponse) {
      this.onDemandResponse.openCaseData.note = note;
    }
  }

  saveNote(): void {
    this.editNote = false;

    if (this.onDemandResponse?.openCaseData?.note) {
      this.saveNoteTextChanged.emit(this.onDemandResponse.openCaseData.note);
    }
  }

  goBack(): void {
    this.location.back();
  }

  onEditNote(): void {
    this.editNote = true;
    this.changeDetectorRef.detectChanges();
    this.focusTextarea();
  }

  focusTextarea(): void {
    this.textareaRef.nativeElement.focus();
  }
}
